<template>
    <v-card class="panelBlock overall-chapter-health">
        <v-layout row wrap>
            <v-flex xs8>
                <h2>{{overallChapterHealthConstants.OVERALL_CHAPTER_HEALTH}}</h2>
            </v-flex>
            <v-flex xs4 text-xs-right pa-3><strong>{{points}} {{overallChapterHealthConstants.OF}} {{overallChapterHealthConstants.MAX_POINTS}} {{overallChapterHealthConstants.POINTS}}</strong></v-flex>
        </v-layout>
        <v-layout row wrap class="overall-chapter-health__header">
            <v-flex xs6>{{overallChapterHealthConstants.METRIC}}</v-flex>
            <v-flex xs2></v-flex>
            <v-flex xs2 text-xs-center>{{overallChapterHealthConstants.METRIC}} <br> {{overallChapterHealthConstants.VALUE}}</v-flex>
            <v-flex xs2 text-xs-center>{{overallChapterHealthConstants.POINTS}} <br> {{overallChapterHealthConstants.GIVEN}}</v-flex>
        </v-layout>
        <v-flex v-for="(data, i) in chapterHealthData" :key="i" class="overall-chapter-health__panel">
            <v-layout row wrap class="overall-chapter-health__tabinfo">
                <v-flex xs6 >{{overallChapterHealthConstants.METRICS[`${data.metric}`]}}</v-flex>
                <v-flex
                    xs2
                    text-xs-center
                    class="overall-chapter-health__help"
                    :data-qe-id="`chapter-health-data_${i}`"
                    @click="data.showHelp = !data.showHelp">
                    <span v-if="!data.showHelp"><i class="far fa-question-circle"></i></span>
                    <span v-else><em class="close">Close</em></span>
                </v-flex>
                <v-flex xs2 text-xs-center :data-qe-id="`chapter-health-data_${i}_metric-value`">
                    <small>{{data.metricValue}}</small>
                </v-flex>
                <v-flex xs2 text-xs-center :data-qe-id="`chapter-health-data_${i}_points-given`">
                    {{data.pointsGiven}}
                </v-flex>
            </v-layout>
            <div class="expand" v-if="data.showHelp">
                <v-flex tag="strong">Explanation :</v-flex>
                <v-flex tag="p"
                        :data-qe-id="`chapter-health-explanation_${i}_data`"
                        v-html="overallChapterHealthConstants.explanation[`${data.metric}`]">
                </v-flex>
            </div>
        </v-flex>
    </v-card>
</template>

<script>
    import { mapGetters } from "vuex";
    import { storeGetters } from "../../../store/storeGetters.constant";
    import { overallChapterHealthConstants } from "./ChapterHealthConstants";
    import { roles } from "../../appCommon.constants";

    export default {
        name: 'OverallChapterHealthView',
        data: () => ({
            overallChapterHealthConstants,
        }),
        created() {
            this.overallChapterHealthData.forEach((c) => {
                c.showHelp = false;
            });
        },        
        computed: {
            ...mapGetters({
                overallChapterHealthData: `chapter/${storeGetters.getOverallChapterHealthData}`,
                overallChapterHealthDataScore: `chapter/${storeGetters.getOverallChapterHealthScore}`,
                communityInfo: `chapter/${[storeGetters.communityInfo]}`,              
                profileInformation: `myAccount/${storeGetters.profileInformation}`,
            }),
            points() {
                return this.overallChapterHealthData.reduce((sum, health) => {
                    return sum + (health.pointsGiven ? health.pointsGiven : 0);
                }, 0);
            },
            isGoldChapter() {         
                return this.communityInfo && this.communityInfo.ypoIType === overallChapterHealthConstants.YPO_GOLD_CHAPTER;
            },
            chapterHealthData() {
                if (this.isGoldChapter) {                 
                    return this.overallChapterHealthData.filter(d => d.metric !== overallChapterHealthConstants.OF_FEMALE_MEMBERS);
                }
                return this.overallChapterHealthData;
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import "../../../common/styles/_colors.scss";

    .overall-chapter-health {
        strong {
            font-size: 14px;
            color: $ypo-blue;
        }

        h2 {
            border-bottom: 0;
        }

        &__header {
            background-color: $ypo-dark-gray;
            padding: 5px 15px;
            font-size: 14px;
            color: $white;
            align-items: center;
            font-weight: 600;
            line-height: normal;
            text-transform: uppercase;
        }

        &__panel {
            background-color: $white;

            .expand {
                color: $ypo-cta;
                font-size: 12px;
                padding: 15px;
                border: 1px solid rgba($ypo-medium-gray, 0.3);
                margin: 15px 10px;
                background-color: $white;
                position: relative;

                &::after,
                &::before {
                    content: "";
                    position: absolute;
                    width: 0;
                    height: 0;
                    border-left: 15px solid transparent;
                    border-right: 15px solid transparent;
                    border-top: 12px solid $ypo-extra-light-gray;
                    top: -17px;
                    left: auto;
                    right: 235px;
                }

                &::before {
                    top: -16px;
                    border-top: 12px solid rgba($black, 0.2);
                }

                p {
                    margin-bottom: 0;
                }

                strong {
                    color: $ypo-cta;
                    font-size: 12px;
                }
            }
        }

        &__help {
            cursor: pointer;
        }

        &__tabinfo {
            background-color: $ypo-extra-light-gray;
            border-bottom: 1px $ypo-open-blue-gray solid;
            font-size: 14px;
            padding: 10px 15px;
            color: $ypo-blue;
            align-items: center;

            span {
                color: $ypo-cta;

                em {
                    font-style: normal;

                }
            }

            small {
                color: $ypo-gray-text;
                font-size: 14px;
            }

        }
    }
</style>
